module.exports = __webpack_public_path__ + "static/media/landing_bye.a61bc711.png";